module.exports = __webpack_public_path__ + "instagram-315dfd44.png";